import React from "react";

export const CHART_COLORS = [
  "var(--color-chart-1)",
  "var(--color-chart-2)",
  "var(--color-chart-3)",
  "var(--color-chart-4)",
  "var(--color-chart-5)",
  "var(--color-chart-6)",
  "var(--color-chart-7)",
  "var(--color-chart-8)",
  "var(--color-chart-9)",
];

export const WeeklyTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  const total = payload.reduce((s: number, e: any) => s + (e.value || 0), 0);
  return (
    <div className="bg-surface border border-border-primary rounded-button px-3 py-2 shadow-md text-body-xs">
      <div className="font-bold text-text-primary mb-1">{label}</div>
      {payload.map((entry: any) => (
        <div key={entry.name} className="flex items-center gap-2 text-body-xs">
          <span className="w-2 h-2 rounded-full" style={{ background: entry.color }} />
          <span className="text-text-secondary">{entry.name === "present" ? "Present" : "Absent"}:</span>
          <span className="font-semibold text-text-primary">
            {entry.value} ({total ? Math.round((entry.value / total) * 100) : 0}%)
          </span>
        </div>
      ))}
    </div>
  );
};

export const CountTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-surface border border-border-primary rounded-button px-3 py-2 shadow-md text-body-xs">
      <div className="font-bold text-text-primary">{label}</div>
      <div className="text-text-secondary">{payload[0].value} employees</div>
    </div>
  );
};

export const StackedBarShape = (props: {
  fill?: string;
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  isTop?: boolean;
  isBottom?: boolean;
  radius?: number;
}) => {
  const { fill, x = 0, y = 0, width = 0, height = 0, isTop = false, isBottom = false, radius = 4 } = props;
  if (!height || height <= 0 || !width || width <= 0) return null;

  const r = Math.min(radius, height, width / 2);

  // Single-segment bar: round all four corners
  if (isTop && isBottom && r > 0) {
    const path = `
      M ${x + r},${y}
      L ${x + width - r},${y}
      Q ${x + width},${y} ${x + width},${y + r}
      L ${x + width},${y + height - r}
      Q ${x + width},${y + height} ${x + width - r},${y + height}
      L ${x + r},${y + height}
      Q ${x},${y + height} ${x},${y + height - r}
      L ${x},${y + r}
      Q ${x},${y} ${x + r},${y}
      Z
    `;
    return <path d={path} fill={fill} />;
  }

  // If this segment is the top of the stack, round only the top corners
  if (isTop && r > 0) {
    const path = `
      M ${x},${y + height}
      L ${x},${y + r}
      Q ${x},${y} ${x + r},${y}
      L ${x + width - r},${y}
      Q ${x + width},${y} ${x + width},${y + r}
      L ${x + width},${y + height}
      Z
    `;
    return <path d={path} fill={fill} />;
  }

  // If this segment is the base of the stack, round only the bottom corners
  if (isBottom && r > 0) {
    const path = `
      M ${x},${y}
      L ${x + width},${y}
      L ${x + width},${y + height - r}
      Q ${x + width},${y + height} ${x + width - r},${y + height}
      L ${x + r},${y + height}
      Q ${x},${y + height} ${x},${y + height - r}
      L ${x},${y}
      Z
    `;
    return <path d={path} fill={fill} />;
  }

  // Otherwise flat rectangle for seamless connection with adjacent segments
  return <rect x={x} y={y} width={width} height={height} fill={fill} />;
};

